import { objToList } from 'utils/util'

export const STATUS_OBJ = {
  1: {
    label: '审批中',
    color: 'blue',
  },
  2: {
    label: '审批通过',
    color: 'green',
  },
  3: {
    label: '审批不通过',
    color: 'red',
  },
}
export const STATUS_LIST = [
  { text: '全部', value: 0 },
  ...objToList(STATUS_OBJ, 'text', 'value'),
]

export const MY_APPROVE_STATUS_OBJ = {
  1: {
    label: '通过',
    color: 'green',
  },
  2: {
    label: '不通过',
    color: 'red',
  },
}
export const MY_APPROVE_STATUS_LIST = objToList(
  MY_APPROVE_STATUS_OBJ,
  'text',
  'value',
)